import {
  OpenCommerceUserCreateMutationOptions,
  OpenCommerceUserUpdateMutationOptions,
  useOpenCommerceUserCreateMutation as useApolloOpenCommerceUserCreateMutation,
  useOpenCommerceUserUpdateMutation as useApolloOpenCommerceUserUpdateMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useOpenCommerceUserCreateMutation = (
  baseOptions?: OpenCommerceUserCreateMutationOptions,
) => useMutation(useApolloOpenCommerceUserCreateMutation, baseOptions);

export const useOpenCommerceUserUpdateMutation = (
  baseOptions: OpenCommerceUserUpdateMutationOptions,
) => useMutation(useApolloOpenCommerceUserUpdateMutation, baseOptions);
